import React, {useEffect, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';

const OutboundGuildRequests = ({guild}) => {
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        if (!guild) {
            return;
        }
        ethereum.guilds.getNewMemberRequestsFromGuild(guild.guildId)
            .then(async (r) => {
                let requests = [];
                for (let request of r) {
                    requests.push(await ethereum.users.getUserName(request.newMember));
                }
                setRequests(Array.from(new Set(requests)));
            });
    }, [guild, setRequests]);

    if (requests.length === 0) {
        return (<div></div>);
    }
    
    console.log('requests = ', requests);
    return (
        <div className="outbound-requests">
          <div className="requests-header">
            Pending Invites
          </div>
          {requests.map(x => <div>{x}</div>)}
        </div>
    );
};

export default OutboundGuildRequests;
